module.exports = __webpack_public_path__ + "img/brand.87e70268.svg";